// src/context/AuthContext.js

import React, { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // User is initially null

  // Simulate social login by setting user data
  const socialLogin = (provider) => {
    const mockUserData = {
      name: provider === "google" ? "Google User" : "Facebook User",
      email:
        provider === "google"
          ? "googleuser@example.com"
          : "facebookuser@example.com",
    };
    setUser(mockUserData);
  };

  const logout = () => {
    setUser(null); // Reset user when logged out
  };

  return (
    <AuthContext.Provider value={{ user, socialLogin, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
